export enum StatsTypeEnum {
  conversations = 'WIDGET.CONVERSATIONS',
  stars = 'WIDGET.STARS',
  conversationsPerHour = 'WIDGET.CONVERSATIONS_PER_HOUR'
}
